import { render, staticRenderFns } from "./CampaignsTable.vue?vue&type=template&id=b3736090"
import script from "./CampaignsTable.vue?vue&type=script&lang=js"
export * from "./CampaignsTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignsTable.vue?vue&type=style&index=0&id=b3736090&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports